import Vue from 'vue'

var GS = {
  Session: null,
  Company: null,
  Language: null,
  Tan: null,
  Endpoint: window.location.href.indexOf("http://localhost") == 0 ? "https://debug-connect.misoft.de" : "https://secmail-api.misoft.de",
  ShowSettings: false, 
  PrefilledMail: null,
  Checkbox1Prefill: undefined,
  RequestCode: null,
  CredentialMode: false
}

var LanguageStrings = {
  de: {
    username: "E-Mail-Adresse",
    username2: "E-Mail-Adresse wiederholen",
    password: "Passwort",
    password2: "Passwort wiederholen",
    anmelden: "Anmelden",
    headline_login: "Bitte melden Sie sich an!",
    passwort_vergessen: "Passwort vergessen",
    loginfailed: "Ungültiges Passwort. Bitte versuchen Sie es erneut!",
    internalservererror: "Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.",
    sessionexpired: "Ihre Sitzung ist abgelaufen. Bitte öffnen Sie Ihre E-Mail erneut.",
    loginblocked: "Aufgrund zu vieler Anmeldeversuche wurde Ihr Zugang für 5 Minuten gesperrt!",
    forgotpassword_mail: "Wir haben Ihnen einen Link per E-Mail gesendet, mit welchem Sie die Möglichkeit haben Ihr Passwort zu ändern.",
    forgotpassword_letter: "Bitte melden Sie sich bei Ihrer Personalabteilung, um Ihr Passwort zurückzusetzen!",
    headline_read: "Inhalt Ihrer sicheren E-Mail:",
    from: "Von",
    to: "An",
    subject: "Betreff",
    date: "Datum",
    emailtext: "E-Mail Text",
    attachments: "Anhänge",
    nav_settings: "Einstellungen",
    nav_logout: "Abmelden",
    nav_disclaimer: "AGB",
    nav_back: "Zurück",
    headline_register: "Registrieren zur sicheren E-Mail",
    tan: "TAN",
    register_email: "E-Mail Adresse gültig",
    register_emailmatch: "E-Mail Adressen sind identisch",
    register_uppercase: "Mindestens ein Großbuchstabe",
    register_lowercase: "Mindestens ein Kleinbuchstabe",
    register_number: "Mindestens eine Zahl",
    register_length: "Passwort mindestens 8 Zeichen lang",
    register_pwmatch: "Passwörter sind identisch",
    register: "Registrieren",
    login_activateemail: "Bitte bestätigen Sie Ihre E-Mail-Adresse, mit dem Aktivierungslink, welchen wir Ihnen zugesendet haben.",
    login_resend_activateemail: "Erneut senden?",
    login_resend_activateemail_ok: "Wir haben Ihnen eine neue E-Mail zugesendet. Bitte prüfen Sie Ihr Postfach.",
    register_ok_mail: "Registrierung erfolgreich! Bitte bestätigen Sie Ihre E-Mail-Adresse, mit dem Aktivierungslink, welchen wir Ihnen zugesendet haben.",
    register_ok: "Registrierung erfolgreich! Sie können nun sichere E-Mails empfangen!",
    register_wrongtan: "Fehler: Ungültige Tan",
    settings_change: "Ändern",
    settings_changemail_head: "E-Mail-Adresse ändern",
    settings_newmail: "Neue E-Mail-Adresse",
    settings_change_password: "Passwort ändern",
    settings_new_password: "Neues Passwort",
    settings_new_password2: "Neues Passwort wiederholen",
    settings_receive: "Empfang sicherer E-Mails aktivieren",
    settings_dontreceive: "Empfang sicherer E-Mails deaktivieren",
    settings_newmail2: "Neue E-Mail-Adresse wiederholen",
    link_expired: "Der von Ihnen aufgerufene Link ist abgelaufen!",
    changepw_successful: "Ihre Passwortänderung wurde erfolgreich durchgeführt. Öffnen Sie Ihre sichere E-Mail bitte erneut!",
    changemail_successful: "Ihre E-Mailadresse wurde erfolgreich geändert!",
    openregister: "Bitte tippen Sie den URL erneut ein.",
    register_already_exists: "Die von Ihnen eingegebene E-Mail-Adresse existiert bereits und kann deswegen nicht verwendet werden!",
    register_credential1: "Sicherheitsmerkmal 1",
    register_credential2: "Sicherheitsmerkmal 2",
    register_credential1_check: "Sicherheitsmerkmal 1 angegeben",
    register_credential2_check: "Sicherheitsmerkmal 2 angegeben",
    register_credentialexists: "Sie haben sich bereits registriert, daher ist keine weitere Registrierung notwendig.",
    register_credentials_wrong: "Fehler: Ungültige Sicherheitsmerkmale",
    esprit_register_credential1: "Geburtsdatum (Format: TTMMYYYY)",
    esprit_register_credential2: "Mitarbeiter-Rabattkartennummer (die letzten 3 Ziffern)",
    esprit_register_credential1_check: "Geburtsdatum angegeben",
    esprit_register_credential2_check: "Rabattkartennummer angegeben",
    esprit_register_credentials_wrong: "Fehler: Ungültiges Geburtsdatum und/oder Rabattkartennummer",
    register_esprit_username: "E-Mail-Adresse (private E-Mail-Adresse empfohlen)",
    esprit_checkbox1: "Ich bin damit einverstanden, über diese Mailadresse zu dem Mitarbeiterumfragetool (&frankly) informiert zu werden. Die Datenschutzerklärung konnte ich zur Kenntnis nehmen.",
    esprit_headline_register: "Registrierung digitaler Entgeltnachweis",
    esprit_sicherheitsmerkmale: "Erfüllte Sicherheitsmerkmale",
    hella_forgotpassword_letter: "Bitte wenden Sie sich an Ihre(n) zuständigen Entgeltsachbearbeiter(in). Für Sie muss eine neue TAN beantragt werden, damit Sie Ihr Passwort neu vergeben können.",
  },
  en: {
    username: "E-mail address",
    username2: "Repeat e-mail address",
    password: "Password",
    password2: "Repeat password",
    anmelden: "Log in",
    headline_login: "Please log in!",
    passwort_vergessen: "Lost password",
    loginfailed: "Invalid password. Please try again!",
    internalservererror: "An unexpected error has occurred. Please try again later.",
    sessionexpired: "Your session has expired. Please reopen your email.",
    loginblocked: "Due to too many login attempts your access has been blocked for 5 minutes!",
    forgotpassword_mail: "We have sent you an email with a link that allows you to change your password.",
    forgotpassword_letter: "Please contact your HR department to reset your password!",
    headline_read: "Content of your secure email:",
    from: "From",
    to: "To",
    subject: "Subject",
    date: "Date",
    emailtext: "E-Mail text",
    attachments: "Attachments",
    nav_settings: "Settings",
    nav_logout: "Logout",
    nav_disclaimer: "Terms and conditions",
    nav_back: "Back",
    headline_register: "Register for secure email",
    tan: "TAN",
    register_email: "E-mail address valid",
    register_emailmatch: "E-mail addresses are identical",
    register_uppercase: "At least one capital letter",
    register_lowercase: "At least one lowercase letter",
    register_number: "At least one number",
    register_length: "Password at least 8 characters long",
    register_pwmatch: "Passwords are identical",
    register: "Sign up",
    login_activateemail: "Please confirm your e-mail address with the activation link we sent you.",
    login_resend_activateemail: "Resend?",
    login_resend_activateemail_ok: "We have sent you a new e-mail. Please check your mailbox.",
    register_ok_mail: "Registration successful! Please confirm your e-mail address with the activation link we sent you.",
    register_ok: "Registration successful! You can now receive secure emails!",
    register_wrongtan: "Error: Invalid Tan",
    settings_change: "Change",
    settings_changemail_head: "Change email address",
    settings_newmail: "New email address",
    settings_change_password: "Change password",
    settings_new_password: "New password",
    settings_new_password2: "Repeat new password",
    settings_receive: "Activate the reception of secure e-mails",
    settings_dontreceive: "Disable secure email reception",
    settings_newmail2: "Repeat new email address",
    link_expired: "The link you requested has expired!",
    changepw_successful: "Your password change was successfully completed. Please open your secure e-mail again!",
    changemail_successful: "Your email address has been successfully changed!",
    openregister: "Please type in the URL again.",
    register_already_exists: "The e-mail address you entered already exists and therefore cannot be used!",
    register_credential1: "Security feature 1",
    register_credential2: "Security feature 2",
    register_credential1_check: "Security feature 1 specified",
    register_credential2_check: "Security feature 2 specified",
    register_credentialexists: "You are already registered, therefore no further registration is necessary.",
    register_credentials_wrong: "Error: Invalid security features",
    esprit_register_credential1: "Date of birth (format: DDMMYYYY)",
    esprit_register_credential2: "Employee discount card number (last 3 digits)",
    esprit_register_credential1_check: "Date of birth indicated",
    esprit_register_credential2_check: "Discount card number specified",
    esprit_register_credentials_wrong: "Error: Invalid date of birth and/or discount card number",
    register_esprit_username: "E-mail address (private email address recommended)",
    esprit_checkbox1: " I agree to be informed via this e-mail address about the employee survey tool (&frankly). I acknowledge that I have read the Privacy Policy Manual.",
    esprit_headline_register: "Registration of digital proof of payment",
    esprit_sicherheitsmerkmale: "Security features fulfilled",
    hella_forgotpassword_letter: "Please contact your responsible payroll administrator. A new TAN must be requested for you so that you can reassign your password.",
  },
  fr: {
    username: "Adresse e-mail",
    username2: "Répéter l'adresse e-mail",
    password: "Mot de passe",
    password2: "Répéter le mot de passe",
    anmelden: "S'identifier",
    headline_login: "Veuillez vous identifier!",
    passwort_vergessen: "Mot de passe oublié",
    loginfailed: "Mot de passe invalide. Veuillez réessayer !",
    internalservererror: "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
    sessionexpired: "Votre session a expiré. Veuillez rouvrir votre courriel.",
    loginblocked: "En raison d'un trop grand nombre de tentatives de connexion, votre accès a été bloqué pendant 5 minutes !",
    forgotpassword_mail: "Nous vous avons envoyé un lien par e-mail, qui vous permettra de modifier votre mot de passe.",
    forgotpassword_letter: "Veuillez contacter votre service du personnel pour réinitialiser votre mot de passe !",
    headline_read: "Contenu de votre courriel sécurisé :",
    from: "De",
    to: "Pour",
    subject: "Thème",
    date: "Sortir avec",
    emailtext: "Texte de l'e-mail",
    attachments: "Pièces jointes",
    nav_settings: "Paramètres",
    nav_logout: "Déconnexion",
    nav_disclaimer: "Conditions générales",
    nav_back: "Retour",
    headline_register: "Inscrivez-vous pour recevoir un courriel sécurisé",
    tan: "TAN",
    register_email: "Adresse e-mail valide",
    register_emailmatch: "Les adresses e-mail sont identiques",
    register_uppercase: "Au moins une majuscule",
    register_lowercase: "Au moins une lettre minuscule",
    register_number: "Au moins un numéro",
    register_length: "Mot de passe d'au moins 8 caractères",
    register_pwmatch: "Les mots de passe sont identiques",
    register: "S'inscrire",
    login_activateemail: "Veuillez confirmer votre adresse e-mail avec le lien d'activation que nous vous avons envoyé.",
    login_resend_activateemail: "Envoyer à nouveau ?",
    login_resend_activateemail_ok: "Nous vous avons envoyé un nouvel e-mail. Veuillez vérifier votre boîte aux lettres.",
    register_ok_mail: "Inscription réussie ! Veuillez confirmer votre adresse e-mail avec le lien d'activation que nous vous avons envoyé.",
    register_ok: "Inscription réussie ! Vous pouvez maintenant recevoir des courriels sécurisés !",
    register_wrongtan: "Erreur : Non valide Tan",
    settings_change: "Changer",
    settings_changemail_head: "Changer l'adresse e-mail",
    settings_newmail: "Nouvelle adresse e-mail",
    settings_change_password: "Modifier le mot de passe",
    settings_new_password: "Nouveau mot de passe",
    settings_new_password2: "Répéter le nouveau mot de passe",
    settings_receive: "Activer la réception d'e-mails sécurisés",
    settings_dontreceive: "Désactiver la réception sécurisée des e-mails",
    settings_newmail2: "Répéter la nouvelle adresse e-mail",
    link_expired: "Le lien que vous avez demandé a expiré !",
    changepw_successful: "Votre changement de mot de passe a été effectué avec succès. Veuillez ouvrir à nouveau votre e-mail sécurisé !",
    changemail_successful: "Votre adresse e-mail a bien été modifiée !",
    openregister: "Veuillez saisir à nouveau l'URL.",
    register_already_exists: "L'adresse e-mail que vous avez saisie existe déjà et ne peut donc pas être utilisée !",
    register_credential1: "Élément de sécurité 1",
    register_credential2: "Élément de sécurité 2",
    register_credential1_check: "Élément de sécurité 1 spécifié",
    register_credential2_check: "Élément de sécurité 2 spécifié",
    register_credentialexists: "Vous êtes déjà inscrit, donc aucune inscription supplémentaire n'est nécessaire.",
    register_credentials_wrong: "Erreur : éléments de sécurité non valides",
    esprit_register_credential1: "Date de naissance (format : JJMMAAAA)",
    esprit_register_credential2: "Numéro de la carte de réduction de l'employé (3 derniers chiffres)",
    esprit_register_credential1_check: "Date de naissance indiquée",
    esprit_register_credential2_check: "Numéro de la carte de réduction spécifié",
    esprit_register_credentials_wrong: "Erreur : date de naissance et/ou numéro de carte de réduction non valide",
    register_esprit_username: "Adresse électronique (adresse email privée recommandée)",
    esprit_checkbox1: "Je confirme que j’accepte d’être informé via cette adresse de courriel / e-mail de l’application de sondage des employés (&frankly). Je confirme avoir reçu l’information des employés concernant la protection des données.",
    esprit_headline_register: "Enregistrement de la preuve numérique de paiement",
    esprit_sicherheitsmerkmale: "Caractéristiques de sécurité respectées",
    hella_forgotpassword_letter: "Veuillez contacter votre responsable de la paie. Un nouveau TAN doit vous être demandé afin que vous puissiez réassigner votre mot de passe.",
  },
  it: {
    username: "Indirizzo email",
    username2: "Ripetere l'indirizzo e-mail",
    password: "Password",
    password2: "Ripetere la password",
    anmelden: "Collegarsi",
    headline_login: "Effettua il login!",
    passwort_vergessen: "Password dimenticata",
    loginfailed: "Password non valida. Riprovaci, per favore!",
    internalservererror: "Si è verificato un errore imprevisto. Si prega di riprovare in un secondo momento.",
    sessionexpired: "La sua sessione è scaduta. Per favore, riaprite la vostra e-mail.",
    loginblocked: "A causa di troppi tentativi di login il tuo accesso è stato bloccato per 5 minuti!",
    forgotpassword_mail: "Vi abbiamo inviato un link via e-mail, che vi permetterà di modificare la vostra password.",
    forgotpassword_letter: "Contatta il tuo reparto Risorse Umane per reimpostare la tua password!",
    headline_read: "Contenuto della tua email sicura:",
    from: "Da",
    to: "A",
    subject: "Tema",
    date: "Dattero",
    emailtext: "Testo e-mail",
    attachments: "Attacchi",
    nav_settings: "Impostazioni",
    nav_logout: "Logout",
    nav_disclaimer: "Termini generali",
    nav_back: "Indietro",
    headline_register: "Registrati per ricevere e-mail sicure",
    tan: "TAN",
    register_email: "Indirizzo e-mail valido",
    register_emailmatch: "Gli indirizzi e-mail sono identici",
    register_uppercase: "Almeno una lettera maiuscola",
    register_lowercase: "Almeno una lettera minuscola",
    register_number: "Almeno un numero",
    register_length: "Password lunga almeno 8 caratteri",
    register_pwmatch: "Le password sono identiche",
    register: "Registro",
    login_activateemail: "Conferma il tuo indirizzo e-mail con il link di attivazione che ti abbiamo inviato.",
    login_resend_activateemail: "Rispedire di nuovo?",
    login_resend_activateemail_ok: "Vi abbiamo inviato una nuova e-mail. Per favore, controlla la tua casella di posta.",
    register_ok_mail: "Registrazione riuscita! Conferma il tuo indirizzo e-mail con il link di attivazione che ti abbiamo inviato.",
    register_ok: "Registrazione riuscita! Ora è possibile ricevere e-mail sicure!",
    register_wrongtan: "Errore: non valido Tan",
    settings_change: "Cambiamento",
    settings_changemail_head: "Cambia indirizzo e-mail",
    settings_newmail: "Nuovo indirizzo e-mail",
    settings_change_password: "Cambiare la password",
    settings_new_password: "Nuova password",
    settings_new_password2: "Ripetere la nuova password",
    settings_receive: "Attivare la ricezione di e-mail sicure",
    settings_dontreceive: "Disattivare la ricezione sicura delle e-mail",
    settings_newmail2: "Ripetere il nuovo indirizzo e-mail",
    link_expired: "Il link richiesto è scaduto!",
    changepw_successful: "La modifica della password è stata completata con successo. Per favore, riaprite la vostra e-mail sicura!",
    changemail_successful: "Il tuo indirizzo e-mail è stato modificato con successo!",
    openregister: "Digitare nuovamente l'URL.",
    register_already_exists: "L'indirizzo e-mail inserito esiste già e quindi non può essere utilizzato!",
    register_credential1: "Funzione di sicurezza 1",
    register_credential2: "Funzione di sicurezza 2",
    register_credential1_check: "Caratteristica di sicurezza 1 specificata",
    register_credential2_check: "Caratteristica di sicurezza 2 specificata",
    register_credentialexists: "Siete già registrati, quindi non è necessaria un'ulteriore registrazione.",
    register_credentials_wrong: "Errore: caratteristiche di sicurezza non valide",
    esprit_register_credential1: "Data di nascita (formato: GGMMAAAA)",
    esprit_register_credential2: "Numero della carta sconto per i dipendenti (ultime 3 cifre)",
    esprit_register_credential1_check: "Data di nascita indicata",
    esprit_register_credential2_check: "Numero di carta sconto specificato",
    esprit_register_credentials_wrong: "Errore: data di nascita non valida e/o numero di carta sconto",
    register_esprit_username: "Indirizzo e-mail (indirizzo e-mail privato consigliato)",
    esprit_checkbox1: "Le confermo di potermi informare su questo indirizzo email riguardo lo strumento di indagine dei dipendenti (&frankly). Inoltre le confermo di aver preso nota sull’informativa della privacy.",
    esprit_headline_register: "Registrazione della prova digitale di pagamento",
    esprit_sicherheitsmerkmale: "Caratteristiche di sicurezza soddisfatte",
    hella_forgotpassword_letter: "Si prega di contattare l'amministratore responsabile del libro paga. È necessario richiedere un nuovo TAN per poter riassegnare la password.",
  },
  pt: {
    username: "Endereço de e-mail",
    username2: "Repetir endereço de e-mail",
    password: "Senha",
    password2: "Repita a senha",
    anmelden: "Iniciar sessão",
    headline_login: "Por favor, inicie sessão!",
    passwort_vergessen: "Senha esquecida",
    loginfailed: "Senha inválida. Por favor, tente novamente!",
    internalservererror: "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.",
    sessionexpired: "A sua sessão expirou. Por favor, reabra o teu e-mail.",
    loginblocked: "Devido a muitas tentativas de login, seu acesso foi bloqueado por 5 minutos!",
    forgotpassword_mail: "Nós lhe enviamos um link via e-mail, que lhe permitirá alterar sua senha.",
    forgotpassword_letter: "Entre em contato com seu departamento de RH para redefinir sua senha!",
    headline_read: "Conteúdo do seu e-mail seguro:",
    from: "De",
    to: "Para",
    subject: "Sujeito",
    date: "Data",
    emailtext: "Texto de e-mail",
    attachments: "Apegos",
    nav_settings: "Configurações",
    nav_logout: "Logout",
    nav_disclaimer: "Termos gerais",
    nav_back: "Voltar",
    headline_register: "Registre-se para receber e-mails seguros",
    tan: "TAN",
    register_email: "Endereço de e-mail válido",
    register_emailmatch: "Os endereços de e-mail são idênticos",
    register_uppercase: "Pelo menos uma letra maiúscula",
    register_lowercase: "Pelo menos uma letra minúscula",
    register_number: "Pelo menos um número",
    register_length: "Senha com pelo menos 8 caracteres",
    register_pwmatch: "As senhas são idênticas",
    register: "Registrar",
    login_activateemail: "Por favor, confirme o seu endereço de e-mail com o link de activação que lhe enviámos.",
    login_resend_activateemail: "Enviar outra vez?",
    login_resend_activateemail_ok: "Enviámos-lhe um novo e-mail. Por favor, verifique a sua caixa de correio.",
    register_ok_mail: "Inscrição bem sucedida! Por favor, confirme o seu endereço de e-mail com o link de activação que lhe enviámos.",
    register_ok: "Inscrição bem sucedida! Agora você pode receber e-mails seguros!",
    register_wrongtan: "Erro: inválido Tan",
    settings_change: "Modificar",
    settings_changemail_head: "Alterar endereço de e-mail",
    settings_newmail: "Novo endereço de e-mail",
    settings_change_password: "Alterar senha",
    settings_new_password: "Nova senha",
    settings_new_password2: "Repita a nova senha",
    settings_receive: "Activar a recepção de e-mails seguros",
    settings_dontreceive: "Desativar recepção segura de e-mail",
    settings_newmail2: "Repetir novo endereço de e-mail",
    link_expired: "O link que você solicitou expirou!",
    changepw_successful: "A sua alteração de senha foi concluída com sucesso. Por favor, abra seu e-mail seguro novamente!",
    changemail_successful: "O seu endereço de e-mail foi alterado com sucesso!",
    openregister: "Por favor, digite a URL novamente.",
    register_already_exists: "O endereço de e-mail que você digitou já existe e, portanto, não pode ser usado!",
    register_credential1: "Função de segurança 1",
    register_credential2: "Função de segurança 2",
    register_credential1_check: "Característica de segurança 1 especificada",
    register_credential2_check: "Característica de segurança 2 especificada",
    register_credentialexists: "Você já está registrado, portanto, não é necessário mais nenhum registro.",
    register_credentials_wrong: "Erro: Características de segurança inválidas",
    esprit_register_credential1: "Data de nascimento (formato: DDMMAAAA)",
    esprit_register_credential2: "Número do cartão de desconto do funcionário (últimos 3 dígitos)",
    esprit_register_credential1_check: "Data de nascimento indicada",
    esprit_register_credential2_check: "Número do cartão de desconto especificado",
    esprit_register_credentials_wrong: "Erro: Data inválida de nascimento e/ou número do cartão de desconto",
    register_esprit_username: "Endereço de correio electrónico (endereço de e-mail privado recomendado)",
    esprit_checkbox1: " I agree to be informed via this e-mail address about the employee survey tool (&frankly). I acknowledge that I have read the Privacy Policy Manual.",
    esprit_headline_register: "Registro de comprovante digital de pagamento",
    esprit_sicherheitsmerkmale: "Características de segurança cumpridas",
    hella_forgotpassword_letter: "Por favor contacte o seu administrador responsável pela folha de pagamento. Um novo TAN deve ser solicitado para você, para que você possa reatribuir sua senha.",
  },
  es: {
    username: "Dirección de correo electrónico",
    username2: "Repetir dirección de correo electrónico",
    password: "Contraseña",
    password2: "Repetir contraseña",
    anmelden: "Iniciar sesión",
    headline_login: "Por favor, identifíquese!",
    passwort_vergessen: "Contraseña Olvidada",
    loginfailed: "Contraseña inválida. Por favor, inténtalo de nuevo!",
    internalservererror: "Se ha producido un error inesperado. Por favor, inténtelo de nuevo más tarde.",
    sessionexpired: "Su sesión ha expirado. Por favor, vuelva a abrir su correo electrónico.",
    loginblocked: "Debido a demasiados intentos de acceso, su acceso ha sido bloqueado durante 5 minutos!",
    forgotpassword_mail: "Le hemos enviado un enlace por correo electrónico, que le permitirá cambiar su contraseña.",
    forgotpassword_letter: "Póngase en contacto con su departamento de Recursos Humanos para restablecer su contraseña!",
    headline_read: "Contenido de su email seguro:",
    from: "Desde",
    to: "Para",
    subject: "Súbdito",
    date: "Salir con",
    emailtext: "Texto de correo electrónico",
    attachments: "Aditamentos",
    nav_settings: "Configuraciones",
    nav_logout: "Cierre de sesión",
    nav_disclaimer: "Condiciones generales",
    nav_back: "Espalda",
    headline_register: "Regístrese para recibir un correo electrónico seguro",
    tan: "TAN",
    register_email: "Dirección de correo electrónico válida",
    register_emailmatch: "Las direcciones de correo electrónico son idénticas",
    register_uppercase: "Por lo menos una letra mayúscula",
    register_lowercase: "Por lo menos una letra minúscula",
    register_number: "Por lo menos un número",
    register_length: "Contraseña de al menos 8 caracteres",
    register_pwmatch: "Las contraseñas son idénticas",
    register: "Registrar",
    login_activateemail: "Por favor, confirme su dirección de correo electrónico con el enlace de activación que le enviamos.",
    login_resend_activateemail: "¿Enviar otra vez?",
    login_resend_activateemail_ok: "Le hemos enviado un nuevo correo electrónico. Por favor, compruebe su buzón de correo.",
    register_ok_mail: "Registro exitoso! Por favor, confirme su dirección de correo electrónico con el enlace de activación que le enviamos.",
    register_ok: "Registro exitoso! Ahora puede recibir correos electrónicos seguros!",
    register_wrongtan: "Error: No válido Tan",
    settings_change: "Cambiar",
    settings_changemail_head: "Cambiar la dirección de correo electrónico",
    settings_newmail: "Nueva dirección de correo electrónico",
    settings_change_password: "Cambiar contraseña",
    settings_new_password: "Nueva contraseña",
    settings_new_password2: "Repetir nueva contraseña",
    settings_receive: "Activar la recepción de e-mails seguros",
    settings_dontreceive: "Desactivar la recepción segura de correo electrónico",
    settings_newmail2: "Repita la nueva dirección de correo electrónico",
    link_expired: "El enlace que ha solicitado ha caducado!",
    changepw_successful: "El cambio de contraseña se ha realizado con éxito. Por favor, abra su correo electrónico seguro de nuevo!",
    changemail_successful: "Su dirección de correo electrónico ha sido cambiada con éxito!",
    openregister: "Por favor, vuelva a escribir la URL.",
    register_already_exists: "La dirección de correo electrónico que ha introducido ya existe y, por lo tanto, no se puede utilizar.",
    register_credential1: "Característica de seguridad 1",
    register_credential2: "Característica de seguridad 2",
    register_credential1_check: "Característica de seguridad 1 especificada",
    register_credential2_check: "Característica de seguridad 2 especificada",
    register_credentialexists: "Usted ya está registrado, por lo que no es necesario ningún otro registro.",
    register_credentials_wrong: "Error: Características de seguridad inválidas",
    esprit_register_credential1: "Fecha de nacimiento (formato: DDMMAAAA)",
    esprit_register_credential2: "Número de la tarjeta de descuento para empleados (últimos 3 dígitos)",
    esprit_register_credential1_check: "Fecha de nacimiento indicada",
    esprit_register_credential2_check: "Número de tarjeta de descuento especificado",
    esprit_register_credentials_wrong: "Error: Fecha de nacimiento inválida y/o número de tarjeta de descuento",
    register_esprit_username: "Dirección de correo electrónico (se recomienda una dirección de correo electrónico privada)",
    esprit_checkbox1: " I agree to be informed via this e-mail address about the employee survey tool (&frankly). I acknowledge that I have read the Privacy Policy Manual.",
    esprit_headline_register: "Registro de comprobante de pago digital",
    esprit_sicherheitsmerkmale: "Características de seguridad cumplidas",
    hella_forgotpassword_letter: "Por favor, contacte con su administrador de nóminas responsable. Se debe solicitar un nuevo TAN para usted para que pueda reasignar su contraseña.",
  },
  nl: {
    username: "E-Mailadres",
    username2: "Herhaal e-mail adres",
    password: "Wachtwoord",
    password2: "Herhaal wachtwoord",
    anmelden: "Aanmelden",
    headline_login: "Gelieve in te loggen!",
    passwort_vergessen: "Wachtwoord vergeten",
    loginfailed: "Ongeldig wachtwoord. Probeer het nog eens!",
    internalservererror: "Er is een onverwachte fout opgetreden. Probeer het later nog eens.",
    sessionexpired: "Uw sessie is verlopen. Gelieve uw e-mail te heropenen.",
    loginblocked: "Door te veel inlogpogingen is uw toegang 5 minuten geblokkeerd!",
    forgotpassword_mail: "Wij hebben u via e-mail een link gestuurd, waarmee u uw wachtwoord kunt wijzigen.",
    forgotpassword_letter: "Neem contact op met uw HR-afdeling om uw wachtwoord opnieuw in te stellen!",
    headline_read: "Inhoud van uw beveiligde e-mail:",
    from: "Van",
    to: "Aan",
    subject: "Onderhevig",
    date: "Datum",
    emailtext: "E-mail Tekst",
    attachments: "Bijvoegsels",
    nav_settings: "Instellingen",
    nav_logout: "Afmelden",
    nav_disclaimer: "Algemene termen",
    nav_back: "Terug",
    headline_register: "Registreer voor beveiligde e-mail",
    tan: "TAN",
    register_email: "E-mail adres geldig",
    register_emailmatch: "E-mailadressen zijn identiek",
    register_uppercase: "Minstens één hoofdletter",
    register_lowercase: "Minstens één kleine letter",
    register_number: "Minstens één nummer",
    register_length: "Wachtwoord ten minste 8 tekens lang",
    register_pwmatch: "Wachtwoorden zijn identiek",
    register: "Register",
    login_activateemail: "Bevestig uw e-mailadres met de activeringslink die wij u hebben toegestuurd.",
    login_resend_activateemail: "Nog een keer sturen?",
    login_resend_activateemail_ok: "We hebben u een nieuwe e-mail gestuurd. Controleer uw mailbox.",
    register_ok_mail: "Registratie succesvol! Bevestig uw e-mailadres met de activeringslink die wij u hebben toegestuurd.",
    register_ok: "Registratie succesvol! U kunt nu beveiligde e-mails ontvangen!",
    register_wrongtan: "Fout: Ongeldig Tan",
    settings_change: "Verandering",
    settings_changemail_head: "Verander e-mail adres",
    settings_newmail: "Nieuw e-mailadres",
    settings_change_password: "Verander wachtwoord",
    settings_new_password: "Nieuw wachtwoord",
    settings_new_password2: "Herhaal nieuw wachtwoord",
    settings_receive: "Activeer de ontvangst van beveiligde e-mailberichten",
    settings_dontreceive: "Veilige e-mailontvangst uitschakelen",
    settings_newmail2: "Herhaal nieuw e-mail adres",
    link_expired: "De door u gevraagde link is verlopen!",
    changepw_successful: "Uw wachtwoordwijziging is succesvol afgerond. Open uw beveiligde e-mail opnieuw!",
    changemail_successful: "Uw e-mailadres is met succes gewijzigd!",
    openregister: "Typ de URL nogmaals in.",
    register_already_exists: "Het door u ingevoerde e-mailadres bestaat al en kan daarom niet worden gebruikt!",
    register_credential1: "Veiligheidskenmerk 1",
    register_credential2: "Veiligheidskenmerk 2",
    register_credential1_check: "Veiligheidskenmerk 1 gespecificeerd",
    register_credential2_check: "Veiligheidskenmerk 2 gespecificeerd",
    register_credentialexists: "U bent al geregistreerd, dus een verdere registratie is niet nodig.",
    register_credentials_wrong: "Fout: Ongeldige veiligheidskenmerken",
    esprit_register_credential1: "Geboortedatum (formaat: DDMMJJJJ)",
    esprit_register_credential2: "Werknemerskortingskaartnummer (laatste 3 cijfers)",
    esprit_register_credential1_check: "Geboortedatum aangegeven",
    esprit_register_credential2_check: "Kortingskaartnummer opgegeven",
    esprit_register_credentials_wrong: "Fout: Ongeldige geboortedatum en/of kortingskaartnummer",
    register_esprit_username: "E-mailadres (aanbevolen privé e-mailadres)",
    esprit_checkbox1: " I agree to be informed via this e-mail address about the employee survey tool (&frankly). I acknowledge that I have read the Privacy Policy Manual.",
    esprit_headline_register: "Registratie van een digitaal betalingsbewijs",
    esprit_sicherheitsmerkmale: "Beveiligingseigenschappen voldaan",
    hella_forgotpassword_letter: "Neem contact op met uw verantwoordelijke salarisadministrateur. Er moet een nieuwe TAN voor u worden aangevraagd, zodat u uw wachtwoord opnieuw kunt toewijzen.",
  },
  pl: {
    username: "Adres E-Mail",
    username2: "Powtórzyć adres e-mail",
    password: "Hasło",
    password2: "Powtórzyć hasło",
    anmelden: "Zaloguj się",
    headline_login: "Proszę się zalogować!",
    passwort_vergessen: "Zapomniane hasło",
    loginfailed: "Nieprawidłowe hasło. Proszę spróbować jeszcze raz!",
    internalservererror: "Wystąpił nieoczekiwany błąd. Proszę spróbować ponownie w późniejszym czasie.",
    sessionexpired: "Twoja sesja wygasła. Proszę, otwórz ponownie swój e-mail.",
    loginblocked: "Z powodu zbyt wielu prób logowania dostęp został zablokowany na 5 minut!",
    forgotpassword_mail: "Wysłaliśmy do Ciebie e-mail z linkiem, który pozwoli Ci na zmianę hasła.",
    forgotpassword_letter: "Prosimy o kontakt z działem HR w celu zresetowania hasła!",
    headline_read: "Zawartość bezpiecznej wiadomości e-mail:",
    from: "Od",
    to: "Do",
    subject: "Narażony",
    date: "Daktyl",
    emailtext: "E-mail Tekst",
    attachments: "Załączniki",
    nav_settings: "Nastawy",
    nav_logout: "Wyloguj",
    nav_disclaimer: "Warunki ogólne",
    nav_back: "Z powrotem",
    headline_register: "Zarejestruj się, aby otrzymywać bezpieczne wiadomości e-mail",
    tan: "TAN",
    register_email: "Adres e-mail ważny",
    register_emailmatch: "Adresy e-mail są identyczne",
    register_uppercase: "Co najmniej jedna duża litera",
    register_lowercase: "Co najmniej jedna mała litera",
    register_number: "Co najmniej jedna liczba",
    register_length: "Hasło o długości co najmniej 8 znaków",
    register_pwmatch: "Hasła są identyczne",
    register: "Rejestrować się",
    login_activateemail: "Proszę potwierdzić swój adres e-mail za pomocą linku aktywacyjnego, który wysłaliśmy do Ciebie.",
    login_resend_activateemail: "Znowu wysłać?",
    login_resend_activateemail_ok: "Wysłaliśmy ci nowy e-mail. Proszę sprawdzić skrzynkę pocztową.",
    register_ok_mail: "Rejestracja powiodła się! Teraz możesz otrzymywać bezpieczne wiadomości e-mail.",
    register_ok: "Rejestracja powiodła się! Teraz możesz otrzymywać bezpieczne e-maile!",
    register_wrongtan: "Błąd: Nieprawidłowy Tan",
    settings_change: "Zmiana",
    settings_changemail_head: "Zmień adres e-mail",
    settings_newmail: "Nowy adres e-mail",
    settings_change_password: "Zmiana hasła",
    settings_new_password: "Nowe hasło",
    settings_new_password2: "Powtórzyć nowe hasło",
    settings_receive: "Aktywuj odbiór bezpiecznych wiadomości e-mail",
    settings_dontreceive: "Wyłącz bezpieczny odbiór poczty elektronicznej",
    settings_newmail2: "Powtórzyć nowy adres e-mail",
    link_expired: "Łącze, o które prosiłeś wygasło!",
    changepw_successful: "Twoja zmiana hasła została pomyślnie zakończona. Proszę otworzyć ponownie swój bezpieczny e-mail!",
    changemail_successful: "Twój adres e-mail został pomyślnie zmieniony!",
    openregister: "Proszę wpisać adres URL ponownie.",
    register_already_exists: "Wprowadzony adres e-mail już istnieje i dlatego nie może być używany!",
    register_credential1: "Zabezpieczenie 1",
    register_credential2: "Zabezpieczenie 2",
    register_credential1_check: "Określona cecha bezpieczeństwa 1",
    register_credential2_check: "Określona cecha bezpieczeństwa 2",
    register_credentialexists: "Jesteś już zarejestrowany, więc dalsza rejestracja nie jest konieczna.",
    register_credentials_wrong: "Błąd: Nieważne zabezpieczenia",
    esprit_register_credential1: "Data urodzenia (format: DDMMRRRR)",
    esprit_register_credential2: "Numer karty rabatowej pracownika (ostatnie 3 cyfry)",
    esprit_register_credential1_check: "Wskazana data urodzenia",
    esprit_register_credential2_check: "Podany numer karty rabatowej",
    esprit_register_credentials_wrong: "Błąd: Nieważna data urodzenia i/lub numer karty rabatowej",
    register_esprit_username: "Adres e-mail (zalecany prywatny adres e-mail)",
    esprit_checkbox1: " I agree to be informed via this e-mail address about the employee survey tool (&frankly). I acknowledge that I have read the Privacy Policy Manual.",
    esprit_headline_register: "Rejestracja cyfrowego dowodu zapłaty",
    esprit_sicherheitsmerkmale: "Spełnione funkcje bezpieczeństwa",
    hella_forgotpassword_letter: "Prosimy o kontakt z odpowiedzialnym administratorem listy płac. Musisz poprosić o nowy TAN, abyś mógł zmienić swoje hasło.",
  },
  zh: {
    username: "邮箱地址",
    username2: "请再次输入您的邮箱地址",
    password: "密码",
    password2: "请再次输入您的密码",
    anmelden: "登录",
    headline_login: "请登录!",
    passwort_vergessen: "忘记密码",
    loginfailed: "密码无效，请重试！",
    internalservererror: "系统错误，请稍后几分钟再试。",
    sessionexpired: "该会话已过期，请重新打开邮件",
    loginblocked: "您的登录已被锁定，请五分钟后再试！",
    forgotpassword_mail: "我们已通过电子邮件发送给您一个链接，使您有机会更改密码。",
    forgotpassword_letter: "请联系HR部门重至密码",
    headline_read: "邮件主体：",
    from: "发件人",
    to: "收件人",
    subject: "主题",
    date: "日期",
    emailtext: "邮件内容",
    attachments: "附件",
    nav_settings: "设置",
    nav_logout: "退出",
    nav_disclaimer: "免责条款与协议",
    nav_back: "后退",
    headline_register: "注册安全邮件",
    tan: "TAN",
    register_email: "邮箱地址 有效",
    register_emailmatch: "邮箱地址相同",
    register_uppercase: "密码中至少需包含一位大写字母",
    register_lowercase: "密码中至少需包含一位小写字母",
    register_number: "密码中至少需包含一位数字",
    register_length: "密码长度至少8位以上",
    register_pwmatch: "密码相同",
    register: "注册",
    login_activateemail: "请点击我们发给您的激活链接以确认您的注册邮箱！",
    login_resend_activateemail: "重新发送？",
    login_resend_activateemail_ok: "我们给您发了一封新邮件，请检查您的邮箱",
    register_ok_mail: "注册成功！请点击我们发给您的激活链接以确认您的注册邮箱。",
    register_ok: "注册成功！！",
    register_wrongtan: "Error: Invalid Tan",
    settings_change: "更改",
    settings_changemail_head: "更改邮箱地址",
    settings_newmail: "新的邮箱地址",
    settings_change_password: "更改密码",
    settings_new_password: "新密码",
    settings_new_password2: "再次输入新密码",
    settings_receive: "激活 安全邮件的接收",
    settings_dontreceive: "注销 安全邮件的接收",
    settings_newmail2: "再次输入新邮件地址",
    link_expired: "您要求的链接已经过期",
    changepw_successful: "您的密码更改已成功完成。请再次打开您的安全电子邮件！",
    changemail_successful: "您的邮箱地址已修改成功",
    openregister: "请再次输入您要访问的地址",
    register_already_exists: "该邮箱地址已被注册，请更换其它邮箱地址!",
    register_credential1: "Security feature 1",
    register_credential2: "Security feature 2",
    register_credential1_check: "Security feature 1 specified",
    register_credential2_check: "Security feature 2 specified",
    register_credentialexists: "You are already registered, therefore no further registration is necessary.",
    register_credentials_wrong: "Error: Invalid security features",
    esprit_register_credential1: "Date of birth (format: DDMMYYYY)",
    esprit_register_credential2: "Employee discount card number (last 3 digits)",
    esprit_register_credential1_check: "Date of birth indicated",
    esprit_register_credential2_check: "Discount card number specified",
    esprit_register_credentials_wrong: "Error: Invalid date of birth and/or discount card number",
    register_esprit_username: "邮箱地址（建议使用私人邮箱）",
    esprit_checkbox1: " I agree to be informed via this e-mail address about the employee survey tool (&frankly). I acknowledge that I have read the Privacy Policy Manual.",
    esprit_headline_register: "Registration of digital proof of payment",
    esprit_sicherheitsmerkmale: "Security features fulfilled",
    hella_forgotpassword_letter: "请联系HR部门重至密码",
  }
};

Vue.mixin({
  data: function () {
    return {
      GS: GS,
      LanguageStrings: LanguageStrings
    }
  },
  computed: {
    Session: function () {
      return GS.Session;
    },
    Company: function () {
      return GS.Company;
    },
    RequestCode: function()
    {
      return GS.RequestCode;
    },
    DisplayLanguage: function () {
      if (GS.Session != null && GS.Language == null) {
        return GS.Session.Language;
      }
      if (GS.Language != null) {
        return GS.Language;
      }

      var browserlang = navigator.language || navigator.userLanguage;
      if(browserlang != undefined && browserlang != null && (browserlang + '').length >= 2)
      {
        browserlang = browserlang.substring(0,2).toLowerCase();

        if(browserlang == "en" || browserlang == "it" || browserlang == "es" || browserlang == "pt" || browserlang == "fr" || browserlang == "nl" || browserlang == "pl" || browserlang == "zh")
        {
          return browserlang;
        }
      }

      return "de";
    }
  },
  methods: {
    form2JSON: function (form) {
      var obj = {};
      var elements = form.querySelectorAll("input, select, textarea");
      for (var i = 0; i < elements.length; ++i) {
        var element = elements[i];
        var name = element.name;
        var value = null;
        if(element.type == "checkbox")
        {
          value = element.checked ? 1 : 0;
        }
        else
        {
          value = element.value;
        }
        

        if (name) {
          obj[name] = value;
        }
      }

      return JSON.stringify(obj);
    },
    humanFileSize: function (bytes, si) {
      var thresh = si ? 1000 : 1024;
      if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
      }
      var units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
      var u = -1;
      do {
        bytes /= thresh;
        ++u;
      } while (Math.abs(bytes) >= thresh && u < units.length - 1);
      return bytes.toFixed(1) + ' ' + units[u];
    }
  }
});